import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import TierPromotionCard from '../../../TierPromotionCard';
import TierPromotionCardWithFellaTooltip from '../../../TierPromotionCardWithFellaTooltip';
import { getBiDataForTierLink } from '../../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import s from './Tier.scss';
var TierMobileThumb = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, responsive = _a.responsive, className = _a.className, style = _a.style, showTierPromotionTooltip = _a.showTierPromotionTooltip;
    var t = useTranslation().t;
    var a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
    var biData = getBiDataForTierLink(deviation);
    // todo: kludge to handle width, height being in `style` too
    var _b = style, styleWidth = _b.width, styleHeight = _b.height, nonDimStyles = __rest(_b, ["width", "height"]);
    var dimensions = responsive ? { width: width } : { width: width, height: height };
    // while we're here, make sure we're not somehow getting different
    // values between these two
    if (width !== styleWidth || height !== styleHeight) {
        ddt.warn('deviationviews.tiermobile', 'dimensions not matching style:', {
            deviationId: deviation.deviationId,
            showTierPromotionTooltip: showTierPromotionTooltip,
            width: width,
            height: height,
            styleWidth: styleWidth,
            styleHeight: styleHeight,
        });
    }
    return (React.createElement("div", { style: __assign(__assign({}, nonDimStyles), dimensions), className: classnames(s['root'], className) },
        showTierPromotionTooltip ? (React.createElement(TierPromotionCardWithFellaTooltip, __assign({ deviation: deviation }, dimensions))) : (React.createElement(TierPromotionCard, __assign({ deviation: deviation, verticalLayout: responsive }, dimensions))),
        React.createElement(BiLink, { className: s['link-overlay'], biData: biData, "aria-label": a11yLabel, href: Url.userSubscriptionsPath({
                username: deviation.author.username,
                tierDeviationId: deviation.deviationId,
                tierContentType: 'deviations',
            }) },
            React.createElement("span", null))));
};
TierMobileThumb.displayName = 'TierMobileThumb';
export default TierMobileThumb;
//# sourceMappingURL=Tier.js.map